export const Greeting = ({name}) => {
    return <h2>Привіт, {name}!</h2>;
}